import { render, staticRenderFns } from "./RenewalAlerttm.vue?vue&type=template&id=5ce4f0e7&"
import script from "./RenewalAlerttm.vue?vue&type=script&lang=js&"
export * from "./RenewalAlerttm.vue?vue&type=script&lang=js&"
import style0 from "./RenewalAlerttm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports